module.exports = __webpack_public_path__ + "static/media/flax.e086f249.jpg";